module.exports = __webpack_public_path__ + "img/img_2.b940f192.jpeg";